import React from 'react';

const App = function () {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          border: '2px solid #eee',
          marginTop: '-40px',
          padding: '10px 30px',
        }}
      >
        <p>The service is temporarily unavailable.</p>
        <p>Please use the Frontapp plugin to work with user data.</p>
        <br />
        <p>
          If you have questions, please reach the CSE team out on #ecosystem-cse
          in the Slack
        </p>
      </div>
    </div>
  );
};

export default App;
